import React from "react";
import { View, Image, StyleSheet } from "react-native";

import { ms, s, vs } from '../utils/responsive';
import { createLogger } from '../utils/logger';
const logger = createLogger('OrnamentBackground');

interface OrnamentBackgroundProps {
  opacity?: number;
}

const OrnamentBackground: React.FC<OrnamentBackgroundProps> = ({ opacity = 0.9 }) => {
  const handleImageError = () => {
    logger.debug("Failed to load ornaments2.png. Check the file path or file integrity.");
  };

  return (
    <View style={styles.container}>
      <Image
        source={require("../assets/ornaments2.png")}
        style={[styles.ornamentsImage, { opacity }]}
        onError={handleImageError} // Log error if image fails to load
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: "50%",
  },
  ornamentsImage: {
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
});

export default OrnamentBackground;